import { businessInfo, testimonials, faqs } from "@/mocks/home";

export default function StructuredData() {
  const data = {
    "@context": "https://schema.org",
    "@type": ["DiagnosticLab", "LocalBusiness"],
    name: businessInfo.name,
    alternateName: businessInfo.shortName,
    description:
      "Laboratorio clínico en Tlalnepantla, Estado de México. Análisis clínicos de rutina y ultrasonido en el laboratorio, y servicio a domicilio para análisis clínicos, electrocardiogramas y rayos X. Precios accesibles y atención humana. Horario de atención de lunes a sábado, de 7:00 a.m. a 1:00 p.m.",
    url: "https://laboratorio-anedan.com/",
    image: businessInfo.logo,
    logo: businessInfo.logo,
    telephone: "+525530062938",
    priceRange: "$",
    currenciesAccepted: "MXN",
    paymentAccepted: "Efectivo, Tarjeta de débito, Tarjeta de crédito",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Cda. Novedades 92, Prensa Nacional",
      addressLocality: "Tlalnepantla",
      addressRegion: "Estado de México",
      postalCode: "54170",
      addressCountry: "MX",
    },
    areaServed: {
      "@type": "City",
      name: "Tlalnepantla, Estado de México",
    },
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        opens: "07:00",
        closes: "13:00",
      },
    ],
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: businessInfo.rating,
      bestRating: "5",
      reviewCount: testimonials.length,
    },
    review: testimonials.map((item) => ({
      "@type": "Review",
      author: { "@type": "Person", name: item.name },
      reviewRating: { "@type": "Rating", ratingValue: String(item.rating), bestRating: "5" },
      reviewBody: item.text,
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: { "@type": "Answer", text: faq.answer },
            })),
          }),
        }}
      />
    </>
  );
}